import { render, staticRenderFns } from "./RequirementView.vue?vue&type=template&id=445305c6&"
import script from "./RequirementView.vue?vue&type=script&lang=js&"
export * from "./RequirementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports